import React, {useEffect, useRef, useState} from 'react';
import Portal from "@Portals/components/Portal";
import datasetParser from "@Dataset/datasetParser";
import FullReview from "@Pages/reviewWidget/components/FullReview";
import useIsDesktop from "@Hooks/selector/useIsDesktop";
import ReviewsList from "@Pages/reviewWidget/components/ReviewsList";
import ReviewMobile from "@Pages/reviewWidget/components/ReviewMobile";
import ErrorBoundary from "@Errors/components/ErrorBoundary";

function ReviewsPortal() {
    const reviewsData = datasetParser({id: "reviews-widget-portal"})

    let reviews = reviewsData ? reviewsData.reviews : []

    const [activeReview, setActiveReview] = useState(reviews[0])

    const isDesktop = useIsDesktop()

    // filter out the duplicates
    if (!reviews[0]?.ticketId) {
        const filtered = [];
        reviews.map((current) => {
            if (!filtered.find((review) => (review.title == current.title && review.text == current.text && review.dateTime == current.dateTime))) {
                filtered.push(current);
            }
        })
        reviews = filtered
    }

    return (
        <ErrorBoundary shouldReload={false}>
            <Portal id="reviews-widget-portal">
                {isDesktop && (
                        <div className="gb--grid">
                            <ReviewsList
                                reviews={reviews}
                                activeReview={activeReview}
                                setActiveReview={setActiveReview}
                            />
                            {activeReview && <FullReview review={activeReview}/>}
                        </div>
                    )}
                {!isDesktop && (
                        <div className="gb--review-list">
                            {
                                reviews?.map((review) => (
                                    <ReviewMobile
                                        review={review}
                                        key={review.ticketId + review.direction}
                                    />
                                ))
                            }
                        </div>
                    )}
            </Portal>
        </ErrorBoundary>
    )
}

export default ReviewsPortal;